import React, { useContext } from "react";
import QuantityCell from '../QuantityCell/QuantityCell';
import { StateContext } from '../../Util/StateContext/StateContext';
import { useCurrentQuantity } from "./useCurrentQuantity";

const QuantityCellState = ({ cell, showTrash, showAddtoRequest }) => {

    const { state, dispatch } = useContext(StateContext);
    const { currentQuantity, setCurrentQuantity } = useCurrentQuantity(state.requests, cell.row.original.id);

    const onChange = (id, value) => {
        if (value > 9999) {
            value = 9999;
        }
        if (value < 0) {
            value = 0;
        }
        setCurrentQuantity(value);
        updateRequestQuantity(id, parseInt(value));
    }

    const updateRequestQuantity = (id, qty) => {
        const currentRequest = state.requests.find(request => request.id === id);
        if (currentRequest) {

            dispatch({
                type: "UPDATE_REQUEST_ITEM_QTY_BY_ID",
                payload: {
                    id: id,
                    qty: qty
                }
            });

            if (qty === 0) {
                removeItemFromRequest(id);
            }
        }
    }

    const addProductToRequest = (product, quanity) => {
        if (state.requests.find(request => request.id === product.id)) {
            dispatch({
                type: "UPDATE_REQUEST_ITEM_QTY_BY_ID",
                payload: {
                    id: product.id,
                    qty: quanity
                }
            })
        } else {
            dispatch({ type: "ADD_TO_REQUEST_CART", payload: { ...product, qty: quanity } });
        }
    }

    const removeItemFromRequest = (id) => {
        dispatch({ type: "REMOVE_REQUEST_ITEM_BY_ID", payload: id });
        setCurrentQuantity(0);
    }

    return (
        <QuantityCell
            currentQuantity={parseInt(currentQuantity)}
            row={cell.row}
            showTrash={showTrash}
            showAddtoRequest={showAddtoRequest}
            onAddToRequest={(product, quanity) => addProductToRequest(product, quanity)}
            onRemoveFromRequest={(request) => removeItemFromRequest(request)}
            onChange={onChange}
        />
    )
}

export default QuantityCellState;